<template>
    <div v-tooltip:bottom="this.invoiced ? Lang.get('messages.orderStatusForInstitution.invoiced') : ''">
        <select v-model="status"
                @change="updateStatus"
                class="form-control"
                v-bind:disabled="invoiced">
            <option v-for="option in options" v-bind:value="option.value">
                {{ option.text }}
            </option>
        </select>
    </div>
</template>

<script>
    export default {
        props: ['item'],

        data() {
            return {
                status: null,
                invoiced: false,
                options: [
                    { text: '', value: null },
                    { text: Lang.get('messages.order.participated'), value: 'participated' },
                    { text: Lang.get('messages.order.not_participated'), value: 'not_participated' },
                    { text: Lang.get('messages.order.maybe'), value: 'maybe' },
                ]
            }
        },

        methods: {
            updateStatus() {
                axios.patch('/admin/orders/items/' + this.item.id + '/institution', { status_institution: this.status })
                    .then(flash(Lang.get('messages.orderStatusForInstitution')))
                    .catch(errors => {
                        console.log(errors.response.data);
                        flash(Lang.get('messages.orderStatusForInstitution.error'), 'danger')
                    });
            }
        },

        created() {
            this.status = this.item.status_institution;
            this.invoiced = this.item.status_manager === 'billed';
        }
    }
</script>
